import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  ButtonGroup,
  FormGroup,
  Label,
  Input,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

function CotizacionesCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_SUBDEPARTAMENTOS = process.env.REACT_APP_URL_SUBDEPARTAMENTOS;
  const URL_DEPARTAMENTOS = process.env.REACT_APP_URL_DEPARTAMENTOS;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  // const URL_COLORES = process.env.REACT_APP_URL_COLORES;
  // const URL_TALLAS = process.env.REACT_APP_URL_TALLAS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_COTIZACIONES = process.env.REACT_APP_URL_COTIZACIONES;
  const URL_ARTICULOS_COTIZACION = process.env.REACT_APP_URL_ARTICULOS_COTIZACION;
  const URL_COMPRADORES = process.env.REACT_APP_URL_COMPRADORES;
  const URL_EMPRESAS = process.env.REACT_APP_URL_EMPRESAS;
  const URL_EXPLOSION_GLOBAL = process.env.REACT_APP_URL_EXPLOSION_GLOBAL;
  const URL_TELAS = process.env.REACT_APP_URL_TELAS;
  const URL_SOCIEDADES = process.env.REACT_APP_URL_SOCIEDADES;
  const URL_AREAS_CLIENTES = process.env.REACT_APP_URL_AREAS_CLIENTES;

  let hoy = new Date()
  // let inicio = new Date()
  // inicio.setDate(inicio.getDate()-60);

  let endDate   = moment(hoy).format("YYYY-MM-DD");
  // let startDate   = moment(inicio).format("YYYY-MM-DD");

  // const ordenTallas = ["2XCH","XXCH","XCH","EXTRA CHICA","CHICA","CH","M","MEDIANA","GRANDE","G","EXTRA GRANDE","XG","2XG","XXG","3XG","XXXG","4XG","XXXXG","5XG","XXXXXG","6XG","ESP","VARIOS","UNITALLA","1","2","3","4","4-6","5","6","7","8","8-10","9","10","10-12","11","12","13","14","14-16","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49","50","51","52","53","54","55","56","57","58","59","60","61","62"];

  const [cotizaciones, setCotizaciones] = useState([]);
  const [selectedCotizacion, setSelectedCotizacion] = useState("");
  const [articulos, setArticulos] = useState([]);
  const [departamentos, setDepartamentos] = useState([]);
  // const [colores, setColores] = useState([]);
  // const [tallas, setTallas] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [empresas, setEmpresas] = useState([]);
  const [selectedEmpresa, setSelectedEmpresa] = useState("");
  const [cotizacionCliente, setCotizacionCliente] = useState("");
  const [colaboradores, setColaboradores] = useState([]);
  const [comprador, setComprador] = useState("");
  const [selectedColaborador, setSelectedColaborador] = useState("");
  const [idArt, setIdArt] = useState("");
  const [idArtPdr, setIdArtPdr] = useState("");
  const [precioEtiqueta, setPrecioEtiqueta] = useState(0);
  const [value, setValue] = useState("");
  // (2026-10) también se cotiza a prospectos del CRM (todavía sin cliente)
  const [destino, setDestino] = useState("cliente"); // cliente | prospecto
  const [prospectos, setProspectos] = useState([]);
  const [prospecto, setProspecto] = useState(null);
  const [precio, setPrecio] = useState();
  const [sociedades, setSociedades] = useState([]);
  const [selectedSociedad, setSelectedSociedad] = useState("");
  const [areasClientesOptions, setAreasClientesOptions] = useState([]);
  const [condiciones, setCondiciones] = useState("");
  // const [selectedSociedad, setSelectedSociedad] = useState("");

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [fecha, setFecha] = useState("");
  const [nombreFirma, setNombreFirma] = useState("");
const [esOtroNombre, setEsOtroNombre] = useState(false);
const [nombreFirmaOtro, setNombreFirmaOtro] = useState("");
  const [puestoFirma, setPuestoFirma] = useState("");
const [esOtroPuesto, setEsOtroPuesto] = useState(false);
const [puestoFirmaOtro, setPuestoFirmaOtro] = useState("");
  const [nombreComprador, setNombreComprador] = useState("");
  const [puestoComprador, setPuestoComprador] = useState("");
  const [cantidadColaboradores, setCantidadColaboradores] = useState(1);
  const [fecha_cancelacion, setFechaCancelacion] = useState("");
  const [fecha_confirmacion, setFechaConfirmacion] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [total_general, setTotalGeneral] = useState(0);
  const [total_piezas, setTotalPiezas] = useState(0);
  const [compradores, setCompradores] = useState([]);
  const [selectedComprador, setSelectedComprador] = useState("");
  const [pendFechaConf, setPendFechaConf] = useState("");

  const [subTotal, setSubTotal] = useState(0);
const [descuento, setDescuento] = useState(0);
const [descuentoDinero, setDescuentoDinero] = useState(0);
const [iva, setIva] = useState(0);
const [impuestos, setImpuestos] = useState(16);

  const [telas, setTelas] = useState([]);
  const [modalExplosiones, setModalExplosiones] = useState(false);
  const toggleExplosiones = () => setModalExplosiones(!modalExplosiones);
  const [inputFieldsTela, setInputFieldsTela] = useState([
    {
      id: uuidv4(),
      idTela: "",
      idColor: "",
      cantidad: 0,
      observaciones: "NA",
    },
  ]);

  const classes = useStyles();
  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      areasClientes: "",
      articulos: "",
      departamentos: "",
      articulosNombre: "",
      cantidad: 0,
      precio: 0,
      descuento: 0,
      tela:"",
      observacionesArticulo: "NA",
    },
  ]);

  const [validaBoton, setValidaBoton] = useState(true);
  useEffect(() => {
  if (!value?._id) {
    setCotizaciones([]);
    setSelectedCotizacion(""); // limpia cotización si cambia cliente
    return;
  }

  const headers = {
    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  };

  axios
    .get(`${URL_COTIZACIONES}Abiertas`, { headers })
    .then((res) => {
      const todas = res.data;
const filtradas = todas.filter((c) => {
  const cotCliente = c.clientes?.[0];
  const cotClienteId = typeof cotCliente === "string" ? cotCliente : cotCliente?._id;
  return String(cotClienteId) === String(value._id);
});


      setCotizaciones(filtradas);
    })
    .catch((err) => {
      console.error("Error al filtrar cotizaciones del cliente:", err);
    });
}, [value]);
// console.log("hola", inputFields)
useEffect(() => {
  if (!selectedCotizacion) return;

  const headers = {
    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  };

  axios
    .get(`${URL_ARTICULOS_COTIZACION}/cotizaciones/${selectedCotizacion}`, { headers })
    .then((resArt) => {
      const datosFormateados = resArt.data.map((a) => {
        const articuloId = a.subDepartamentos?.[0]._id || "";
        const articulo = a.subDepartamentos?.[0] || {}; // si viene populado

        const codigo = articulo.name || ""; // o usa nombre si aplica
        const descripcion = articulo.name ||  "";
        const nombreCompleto = `${descripcion}`.trim();

        return {
          id: uuidv4(),
          areasClientes: a.areasClientes?.[0]?._id || "",
          departamentos: a.departamentos?.[0]._id || "",
          articulos: articuloId,
          articulosNombre: descripcion,
          cantidad: a.cantidad || 0,
          descuento: a.descuento || 0,
          precio: a.precio || 0,
          tela: a.tela || "",
          total: a.total || 0,
          observacionesArticulo: a.observacionesArticulo || "NA",
        };
      });

      setInputFields(datosFormateados);
    })
    .catch((err) =>
      console.error("Error al cargar artículos de cotización:", err)
    );
}, [selectedCotizacion]);



  useEffect(() => {
    axios
      .get(URL_SUBDEPARTAMENTOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allArticulos = res.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_DEPARTAMENTOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allDepartamentos = res.data;
        setDepartamentos(allDepartamentos);
      })
      .catch((err) => {
        console.log(err);
      });
    // axios
    //   .get(URL_COLORES, {
    //     headers: {
    //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    //     },
    //   })
    //   .then((res) => {
    //     const allColores = res.data;
    //     setColores(allColores);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
    // axios
    //   .get(URL_TALLAS, {
    //     headers: {
    //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    //     },
    //   })
    //   .then((res) => {
    //     const allTallas = res.data;
    //     setTallas(allTallas);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
    axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allClientes = res.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_COLABORADORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allColaboradores = res.data;
        setColaboradores(allColaboradores);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_COMPRADORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allCompradores = res.data;
        setCompradores(allCompradores);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_EMPRESAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allEmpresa = response.data;
        setEmpresas(allEmpresa);
        //
      })
      .catch((err) => {
        console.log(err);
      });
      axios
    .get(URL_TELAS, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((res) => {
      const allTelas = res.data;
      setTelas(allTelas);
    })
    axios
    .get(URL_SOCIEDADES, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((res) => {
      const allSociedades = res.data;
      setSociedades(allSociedades);
    })
    .catch((err) => {
      console.log(err);
    });
  // (2026-11) antes del return: con prospecto no hay value y al quitar un renglón
  // el total se quedaba con el importe anterior
  ActualizaTotales()
if (!value?._id) {
    setAreasClientesOptions([]);
    return;
  }

  axios
    .get(`${URL_AREAS_CLIENTES}/cliente/${value._id}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((res) => {
      const allAreasClientes = res.data || [];
      setAreasClientesOptions(allAreasClientes);
    })
    .catch((err) => {
      console.log(err);
      setAreasClientesOptions([]);
    });
  }, [inputFields, value._id]);

  // (2026-10) prospectos del CRM que todavía no son clientes; ?prospecto=id
  // (botón "Cotizar" del CRM) lo deja elegido
  const datoProspecto = (v) => (v && String(v).trim().toUpperCase() !== "NA" ? String(v).trim() : "");
  const nombreProspecto = (p) =>
    p
      ? `${datoProspecto(p.empresa) || datoProspecto(p.razon_social)}${
          datoProspecto(p.contacto) ? ` · ${datoProspecto(p.contacto)}` : ""
        }`
      : "";
  function eligeProspecto(p) {
    setDestino("prospecto");
    setProspecto(p || null);
    setValue("");
    setSelectedCotizacion("");
    setCondiciones("");
    setNombreComprador(datoProspecto(p?.contacto));
    setPuestoComprador(datoProspecto(p?.cargo));
    setInputFields((prev) => prev.map((item) => ({ ...item, areasClientes: "" })));
  }
  useEffect(() => {
    axios
      .get(process.env.REACT_APP_URL_CRM_PROSPECTOS, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((res) => {
        const lista = (res.data || []).filter((p) => p.is_active !== "No" && !p.cliente);
        setProspectos(lista);
        const id = new URLSearchParams(window.location.search).get("prospecto");
        const elegido = id && lista.find((p) => String(p._id) === id);
        if (elegido) eligeProspecto(elegido);
      })
      .catch((err) => console.log(err));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const saveCotizacion = async (event) => {
    event.preventDefault();

    const esProspecto = destino === "prospecto";
    if (esProspecto ? !prospecto?._id : !value?._id) {
      return Swal.fire({
        icon: "warning",
        title: esProspecto ? "Falta prospecto" : "Falta cliente",
        text: esProspecto
          ? "Selecciona el prospecto al que va la cotización."
          : "Selecciona el cliente al que va la cotización.",
      });
    }
    const quien = esProspecto ? `Prospecto ${prospecto._id}` : value._id;

    // L14 (2026-06) — validación: empresa requerida (sin esto el back tira 400 silencioso)
    if (!selectedEmpresa) {
      return Swal.fire({
        icon: "warning",
        title: "Falta empresa",
        text: "Selecciona la Empresa antes de guardar la cotización.",
      });
    }

    setValidaBoton(false);
    toggleProgreso();

    let totalCotizacion = inputFields.length
    const nombreFinal = nombreFirma === "Otro" ? nombreFirmaOtro : nombreFirma;
    const puestoFinal = puestoFirma === "Otro" ? puestoFirmaOtro : puestoFirma;

    try {
      await axios
        .post(
          URL_COTIZACIONES,
          {
            fecha,
            descuento,
            ...(esProspecto ? { crmProspectos: prospecto._id } : { clientes: value._id }),
            colaboradores: selectedColaborador,
            empresas: selectedEmpresa,
            observaciones,
            subTotal,
            total_general,
            total_piezas,
            status: "Abierto",
            compradores: "6776c839c763d45da2f0f5b7",
            sociedades: "6775c905d688145c579d8393",
            nombreFirma: nombreFinal,
            puestoFirma: puestoFinal,
            nombreComprador,
            puestoComprador,
            cantidadColaboradores,
            condiciones
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then((data) => {
          // L116 (2026-06) — consecutivo de captura: se asigna en el orden síncrono
          // del map (orden real de alta), independiente de cuándo termine cada POST.
          let ordenArticulo = 0;
          inputFields.map((a) => {
            if (a.articulos) {
                ordenArticulo += 1;
                axios
                  .post(
                    URL_ARTICULOS_COTIZACION,
                    {
                      cotizaciones: data.data._id,
                      departamentos: a.departamentos,
                      subDepartamentos: a.articulos,
                      articuloNombre: a.articulosNombre,
                      // colores: b.colores,
                      // tallas: b.tallas,
                      tela: a.tela,
                      cantidad: a.cantidad,
                      descuento,
                      precio: a.precio,
                      total: a.total,
                      orden: ordenArticulo, // L116
                      sociedades: "6775c905d688145c579d8393",
                      // sociedades: selectedSociedad,
                      // (2026-10) los prospectos no tienen áreas; vacío lo rechaza el validador
                      ...(a.areasClientes ? { areasClientes: a.areasClientes } : {}),
                      observacionesArticulo: a.observacionesArticulo || "NA",
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`,
                      },
                    }
                  )
                  .then(() => {
                    totalCotizacion = totalCotizacion - 1;
                    if (totalCotizacion == 0) {
                      axios
                        .post(
                          URL_LOGS,
                          {
                            tipo: "Crear Cotizacion",
                            detalle: `${quien} ${total_general}`,
                            user: user.id,
                          },
                          {
                            headers: {
                              Authorization: `Bearer: ${localStorage.getItem(
                                "app_token"
                              )}`,
                            },
                          }
                        )
                        .then(() => {
                          // L93 (2026-06) — al guardar, abrir el PDFOC en ListadoCotizaciones
                          localStorage.setItem("autoPDFCotizacion", data.data._id);
                          Swal.fire("Good job!", `Creado con exito, Cotizacion ${data.data.idCotizacion}`, `success`);
                          setTimeout(() => {
                            window.location.href = "/ListadoCotizaciones";
                          }, 1500);
                        });
                    }
                  });

            } else {
              totalCotizacion = totalCotizacion - 1;
              if (totalCotizacion == 0) {
                axios
                  .post(
                    URL_LOGS,
                    {
                      tipo: "Crear Cotizacion",
                      detalle: `${quien} ${total_general}`,
                      user: user.id,
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`,
                      },
                    }
                  )
                  .then(() => {
                    Swal.fire("Good job!", `Creado con exito, Cotizacion ${data.data.idCotizacion}`, `success`);
                    setTimeout(() => {
                      window.location.reload();
                    }, 2000);
                  });
              }
            }
          })

          // inputFieldsTela.map((a) => {
          //   if ((a.idTela != "") && (a.idColor != "") && (a.cantidad > 0)) {
          //     axios
          //       .post(
          //         URL_EXPLOSION_GLOBAL,
          //         {
          //           articulos: idArt,
          //           cotizaciones: data.data._id,
          //           telas: a.idTela,
          //           colores: a.idColor,
          //           cantidad: a.cantidad,
          //           tipo: "Tela",
          //           observaciones: a.observaciones,
          //         },
          //         {
          //           headers: {
          //             Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          //           },
          //         }
          //       )
          //       .then(() => {
          //         totalCotizacion = totalCotizacion - 1;
          //         if (totalCotizacion == 0) {
          //           axios
          //             .post(
          //               URL_LOGS,
          //               {
          //                 tipo: "Agregar Explosion",
          //                 detalle: `${idArt} ${a.idTela}`,
          //                 user: user.id,
          //               },
          //               {
          //                 headers: {
          //                   Authorization: `Bearer: ${localStorage.getItem(
          //                     "app_token"
          //                   )}`,
          //                 },
          //               }
          //             )
          //             .then(() => {
          //               Swal.fire("Good job!", `Creado con exito, Cotizacion ${data.data.idCotizacion}`, `success`);
          //               setTimeout(() => {
          //                 window.location.reload();
          //               }, 2000);
          //             });
          //         }
          //       });
          //   } else {
          //     totalCotizacion = totalCotizacion - 1;
          //   }
          // });

        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
          setValidaBoton(true);
        });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response.data}`,
      });
      console.log(error);
    }
  };

 const handleAddFields = () => {
  setInputFields((prevFields) => [
    ...prevFields,
    {
     id: uuidv4(),
      areasClientes: "",
      departamentos: "",
      articulos: "",
      articulosNombre: "",
      // colores: "",
      // arrayColoresArticulo: [],
      // tallas: "",
      // arrayTallasArticulo: [],
      cantidad: 0,
      precio: 0,
      descuento: 0,
      total: 0,
      // tc: [],
      // totalArt: 0,
      tela:"",
      observacionesArticulo: "NA"
    },
  ]);
};

const handleRemoveFields = (id) => {
  setInputFields((prevFields) =>
    prevFields.length > 1
      ? prevFields.filter((field) => field.id !== id)
      : prevFields
  );
  ActualizaTotales()
};

  const handleChangeInput = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
        let totalParcial = i.totalArt * parseFloat(precio);
        i.total = totalParcial
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  // const handleChangeInputCantidad = (id, colores, tallas, event) => {
  //   const newInputFields = inputFields.map((i) => {
  //     if (id === i.id) {
  //       i.tc.map((a) => {
  //         if (a.colores == colores && a.tallas == tallas) {
  //           a.cantidad = event.target.value;
  //         }
  //       });

  //       let can = i.tc.map((c) => parseFloat(c.cantidad));
  //       let TC = can.reduce((t, total, index) => t + total, 0);

  //       i.totalArt = TC;
  //       let totalParcial = i.totalArt * parseFloat(precio);
  //       i.total = totalParcial;
  //     }
  //     return i;
  //   });
  //   setInputFields(newInputFields);

  //   ActualizaTotales();
  // };

  function BuscaArticulo(id, selectedArticulo) {
    articulos.map((a) => {
      if (a._id == selectedArticulo._id) {
        let idArticulo = a._id;
        let articulosNombre = a.name;
        handleChangeInputArticulo(
          id,
          idArticulo,
          articulosNombre
        );
      }
    });
  }

  const handleChangeInputArticulo = (
    id,
    idArticulo,
    articulosNombre
  ) => {
    setIdArt(idArticulo);
    const newInputFields2 = [];

    // let coloresArray = Object.values(coloresArticulo);
    // let tallasArray = Object.values(tallasArticulo);

    // coloresArray.map((a) => {
    //   tallasArray.map((b) => {
    //     newInputFields2.push({
    //       colores: a._id,
    //       colorNombre: a.name,
    //       tallas: b._id,
    //       tallaNombre: b.name,
    //       cantidad: 0,
    //     });
    //   });
    // });

    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        i.articulosNombre = articulosNombre
      }
      return i;
    });
    setInputFields(newInputFields);

    ActualizaTotales();
  };

const ActualizaTotales = (
  fields = inputFields,
  desc = descuento,
  imp = impuestos
) => {
  let totalPiezas = 0;
  let subtotalDinero = 0;

  fields.forEach((field) => {
    totalPiezas += parseFloat(field.cantidad) || 0;
    subtotalDinero += parseFloat(field.total) || 0;
  });

  const descPorcentaje = parseFloat(desc) || 0;
  const impuestoPorcentaje = parseFloat(imp) || 0;

  const descDinero = subtotalDinero * (descPorcentaje / 100);
  const baseIVA = subtotalDinero - descDinero;
  const ivaCalculado = baseIVA * (impuestoPorcentaje / 100);

  // Si NO quieres sumar IVA al total, déjalo así:
  const totalFinal = baseIVA;

  setTotalPiezas(totalPiezas);
  setSubTotal(parseFloat(subtotalDinero.toFixed(2)));
  setDescuentoDinero(parseFloat(descDinero.toFixed(2)));
  setIva(parseFloat(ivaCalculado.toFixed(2)));
  setTotalGeneral(parseFloat(totalFinal.toFixed(2)));
};


  function explosiones() {
    
    setInputFieldsTela([
      {
        id: uuidv4(),
        idTela: "",
        idColor: "",
        cantidad: 0,
        observaciones: "NA",
      },
    ]);
    toggleExplosiones();
  }


  const options = clientes.map((option) => {
    const junta = option.nombre_comercial;
    const firstLetter = option.nombre_comercial[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });

const handleInputFieldChange = (id, fieldName, value) => {
  setInputFields((prevFields) => {
    const updatedFields = prevFields.map((field) => {
      if (field.id === id) {
        const updatedField = { ...field, [fieldName]: value };

        // Si cambia precio o cantidad, recalcula total del artículo
        if (fieldName === "precio" || fieldName === "cantidad") {
          const precio = parseFloat(updatedField.precio) || 0;
          const cantidad = parseFloat(updatedField.cantidad) || 0;

          updatedField.total = parseFloat((precio * cantidad).toFixed(2));
        }

        return updatedField;
      }
      return field;
    });

    // Llama a ActualizaTotales después de actualizar inputFields
    setTimeout(() => {
      ActualizaTotales(updatedFields);
    }, 0);

    return updatedFields;
  });
};

console.log("hola", nombreFirma)
const handleChangeInputCantidad = (idField, idColor, idTalla, event) => {
  const nuevaCantidad = parseInt(event.target.value) || 0;

  setInputFields((prevFields) =>
    prevFields.map((field) => {
      if (field.id === idField) {
        const nuevaTC = field.tc.map((tcItem) => {
          if (tcItem.colores === idColor && tcItem.tallas === idTalla) {
            return { ...tcItem, cantidad: nuevaCantidad };
          }
          return tcItem;
        });

        const nuevoTotalArt = nuevaTC.reduce(
          (acc, item) => acc + (parseInt(item.cantidad) || 0),
          0
        );

        const nuevoTotal = parseFloat(
          (nuevoTotalArt * field.precio * (1 - field.descuento / 100)).toFixed(2)
        );

        return {
          ...field,
          tc: nuevaTC,
          totalArt: nuevoTotalArt,
          total: nuevoTotal,
        };
      }
      return field;
    })
  );
  ActualizaTotales()
};


  const options2 = articulos.map((option) => {
    const junta =  option.name
    const firstLetter = option.name[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });
// console.log("hola", inputFields)
  return (
    <>
      <Header />
      <br />
      <br />
      {user.pedidos_create ? (
        <div className="card container col-12">
          <h3 align="center">Nueva Cotizacion</h3>
          <Form onSubmit={saveCotizacion}>
            <Row>
              
              <Col md={2}>
                <Label>Fecha</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fecha}
                  required
                  onChange={(e) => {
                    setFecha(e.target.value);
                  }}
                />
              </Col>

              {/* L14 (2026-06) — selector de Empresa, igual que en PedidosCreate */}
              <Col md={2}>
                <Label className="mr-sm-2">Empresa</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedEmpresa}
                  required
                  onChange={(e) => {
                    setSelectedEmpresa(e.target.value);
                  }}
                >
                  <option value="">Selecciona</option>
                  {empresas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => (
                      <option key={a._id} value={a._id}>
                        {a.name}
                      </option>
                    ))}
                </Input>
              </Col>

              <Col md={2}>
  {/* (2026-10) a un cliente o a un prospecto del CRM */}
  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 4 }}>
    <Label className="mr-sm-2" style={{ marginBottom: 0 }}>
      {destino === "prospecto" ? "Prospecto" : "Cliente"}
    </Label>
    <ButtonGroup size="sm">
      <Button
        color={destino === "cliente" ? "info" : "secondary"}
        style={{ padding: "0 6px", fontSize: 11 }}
        onClick={() => {
          setDestino("cliente");
          setProspecto(null);
        }}
      >
        Cliente
      </Button>
      <Button
        color={destino === "prospecto" ? "info" : "secondary"}
        style={{ padding: "0 6px", fontSize: 11 }}
        onClick={() => eligeProspecto(null)}
      >
        Prospecto
      </Button>
    </ButtonGroup>
  </div>

  {destino === "prospecto" ? (
    <>
      <Autocomplete
        size="small"
        value={prospecto}
        onChange={(event, p) => eligeProspecto(p)}
        options={prospectos
          .slice()
          .sort((a, b) => nombreProspecto(a).localeCompare(nombreProspecto(b), "es"))}
        getOptionLabel={(p) => nombreProspecto(p)}
        getOptionSelected={(p, v) => String(p?._id) === String(v?._id)}
        renderInput={(params) => (
          <TextField {...params} label="Selecciona" variant="outlined" />
        )}
      />
      <small className="text-muted">
        Al convertirse en cliente (CRM), la cotización pasa a ese cliente.
      </small>
    </>
  ) : (
  <>
  <Autocomplete
    size="small"
    value={value}
    onChange={(event, selectedCliente) => {
      setValue(selectedCliente);

      // 👇 AQUÍ SE AUTOSELECCIONA EL VENDEDOR
      if (selectedCliente?.contacto) {
        const colRaw = selectedCliente.contacto[0];
        const colId = typeof colRaw === "string" ? colRaw : colRaw?._id;
        setSelectedColaborador(colId);
        // L90 (2026-06) — Nombre Firma jala nombre+apellido del vendedor (directo, no "Otro")
        const col =
          colRaw && colRaw.nombre
            ? colRaw
            : colaboradores.find((c) => c._id === colId) || colRaw;
        const nombreCompleto = `${col?.nombre || ""} ${
          col?.apellido || ""
        }`.trim();
        if (nombreCompleto) {
          setNombreFirma(nombreCompleto);
          setEsOtroNombre(false);
          setNombreFirmaOtro("");
        }
      } else {
        setSelectedColaborador(""); // por si no trae vendedor
      }
       // 👇 Cargar condiciones de cotización del cliente
    if (selectedCliente?.condicionesCotizacion) {
      setCondiciones(selectedCliente.condicionesCotizacion);
    } else {
      setCondiciones("");
    }
      setInputFields((prev) =>
    prev.map((item) => ({
      ...item,
      areasClientes: "",
    }))
  );
    }}
    options={options.sort(
      (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
    )}
    groupBy={(option) => option.firstLetter}
    getOptionLabel={(option) => option.junta}
    renderInput={(params) => (
      <TextField {...params} label="Selecciona" variant="outlined" />
    )}
    renderOption={(option) => (
      <React.Fragment>{option.nombre_comercial}</React.Fragment>
    )}
  />
   <Button
      color="info"
      size="sm"
      className="ms-2"
      onClick={() => window.open("/clientesCreate", "_blank")}
    >
      Nuevo
    </Button>
    <Label className="mr-sm-2">(Refrescar la página)</Label>
  </>
  )}
</Col>

<Col md={2}>
               <Label className="mr-sm-2">Cotizacion Anterior (Opcional)</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  disabled={!value?._id}
                  value={selectedCotizacion}
                  onChange={(e) => {
                    setSelectedCotizacion(e.target.value);
                  }}
                >
                  <option value="0">Selecciona</option>
                  {cotizaciones
                    .sort((a, b) => (a.idCotizacion > b.idCotizacion ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.idCotizacion}</option>;
                    })}
                </Input>
                </Col>
              <Col md={2}>
                <Label>Vendedor</Label>
                <Input
                  type="select"
                  required
                  value={selectedColaborador}
                  onChange={(e) => {
                    const idCol = e.target.value;
                    setSelectedColaborador(idCol);
                    // L90 (2026-06) — Nombre Firma jala nombre+apellido del vendedor (directo, no "Otro")
                    const col = colaboradores.find((c) => c._id === idCol);
                    if (col) {
                      const nombreCompleto = `${col.nombre || ""} ${
                        col.apellido || ""
                      }`.trim();
                      if (nombreCompleto) {
                        setNombreFirma(nombreCompleto);
                        setEsOtroNombre(false);
                        setNombreFirmaOtro("");
                      }
                    }
                  }}
                >
                  <option value="">Selecciona un Vendedor</option>
                  {colaboradores
                    .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                    .map((a) => {
                        return (
                          <option value={a._id}>
                            {a.nombre} {a.apellido}
                          </option>
                        );
                    })}
                </Input>
              </Col>
              <Col md={2}>
                <Label>Cantidad Colaboradores</Label>
                <Input
                  type="number"
                  placeholder="Cantidad Colaboradores"
                  value={cantidadColaboradores}
                  required
                  onChange={(e) => {
                    setCantidadColaboradores(e.target.value);
                  }}
                />
              </Col>
            </Row>

              <Row>
              
{/* <Col md={2}>
  <Label>Nombre Firma</Label>
  <Input
    type="select"
    value={nombreFirma}
    required
    onChange={(e) => {
      const value = e.target.value;
      setNombreFirma(value);

      if (value === "Otro") {
        setEsOtroNombre(true);
      } else {
        setEsOtroNombre(false);
        setNombreFirmaOtro("");
      }
    }}
  >
    <option value="">Selecciona</option>
    <option value="Alberto Penhos">Alberto Penhos</option>
    <option value="Alexander Penhos">Alexander Penhos</option>
    <option value="Ana Laura Barrios">Ana Laura Barrios</option>
    <option value="Emilio Penhos">Emilio Penhos</option>
    <option value="Enrique de la Cruz">Enrique de la Cruz</option>
    <option value="Erica Leal">Erica Leal</option>
    <option value="Luis Gabriel Sanchez">Luis Gabriel Sanchez</option>
    <option value="Magali Nava">Magali Nava</option>
    <option value="Ma. Concepcion Perez">Ma. Concepcion Perez</option>
    <option value="Miguel Sanchez">Miguel Sanchez</option>
    <option value="Mireya Balderas">Mireya Balderas</option>
    <option value="Nissim Mann">Nissim Mann</option>
    <option value="Pedro Castellanos">Pedro Castellanos</option>
    <option value="Otro">Otro</option>
  </Input>

  {esOtroNombre && (
    <Input
      type="text"
      placeholder="Escribe el nombre"
      value={nombreFirmaOtro}
      required
      className="mt-2"
      onChange={(e) => setNombreFirmaOtro(e.target.value)}
    />
  )}
</Col> */}


               <Col md={2}>
  <Label>Puesto Firma</Label>
  <Input
    type="select"
    value={puestoFirma}
    required
    onChange={(e) => {
      const value = e.target.value;
      setPuestoFirma(value);

      if (value === "Otro") {
        setEsOtroPuesto(true);
      } else {
        setEsOtroPuesto(false);
        setPuestoFirmaOtro("");
      }
    }}
  >
    <option value="">Selecciona</option>
    <option value="Administrativo Ventas">Administrativo Ventas</option>
    <option value="Director General">Director General</option>
    <option value="Director Logistica">Director Logistica</option>
    <option value="Director Produccion">Director Produccion</option>
    <option value="Director Ventas">Director Ventas</option>
    <option value="Ejecutivo Ventas">Ejecutivo Ventas</option>
    <option value="Otro">Otro</option>
  </Input>

  {esOtroPuesto && (
    <Input
      type="text"
      placeholder="Escribe el puesto"
      value={puestoFirmaOtro}
      required
      className="mt-2"
      onChange={(e) => setPuestoFirmaOtro(e.target.value)}
    />
  )}
</Col>

            {/* </Row>
            <Row> */}
              {/* <Col md={2}>
                <Label>Fecha Confirmacion</Label>
                <Input
                  type="date"
                  placeholder="Fecha Confirmacion"
                  value={fecha_confirmacion}
                  required
                  onChange={(e) => {
                    setFechaConfirmacion(e.target.value);
                  }}
                />
              </Col>
                  <Col md={2}>
                    <Label className="mr-sm-2">Pendiente Fecha Conf</Label>
                    <Input
                      className="col-sm-12"
                      type="select"
                      value={pendFechaConf}
                      required
                      onChange={(e) => {
                        setPendFechaConf(e.target.value);
                      }}
                    >
                      <option value="">Selecciona</option>
                      <option value="Si">Si</option>
                      <option value="No">No</option>
                    </Input>
                  </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Comprador</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedComprador}
                  required
                  onChange={(e) => {
                    setSelectedComprador(e.target.value);
                  }}
                >
                  <option value="0">Selecciona</option>
                  {compradores
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </Col> */}
              {/* <Col md={2}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Cotizacion Cliente
                </Label>
                <Input
                  type="text"
                  placeholder="Cotizacion Cliente"
                  value={cotizacionCliente}
                  required
                  onChange={(e) => {
                    setCotizacionCliente(e.target.value);
                  }}
                />
              </Col> */}
              {/* <Col md={2}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Observaciones Diseño
                </Label>
                <Input
                  type="text"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col> */}
              {/* <Col md={2}>
              <Label for="exampleEmail" className="mr-sm-2">
                    Agregar Consumo
                  </Label>
                  <br />
              <Button
                            color="success"
                            id="explosion"
                            onClick={(e) =>
                              explosiones()
                            }
                          >
                            <i class="fas fa-tape"></i>
                          </Button>
              </Col> */}
                <Col md={2}>
                <Label>Nombre Comprador</Label>
                <Input
                  type="text"
                  placeholder="Nombre Comprador"
                  value={nombreComprador}
                  required
                  onChange={(e) => {
                    setNombreComprador(e.target.value);
                  }}
                />
              </Col>
               <Col md={2}>
                <Label>Puesto Comprador</Label>
                <Input
                  type="text"
                  placeholder="Puesto Comprador"
                  value={puestoComprador}
                  required
                  onChange={(e) => {
                    setPuestoComprador(e.target.value);
                  }}
                />
              </Col>
               
<Col md={2}>
  <Label>Descuento %</Label>
  <Input
    type="number"
    value={descuento}
    onChange={(e) => {
      const nuevoDescuento = parseFloat(e.target.value) || 0;
      setDescuento(nuevoDescuento);
      ActualizaTotales(inputFields, nuevoDescuento);
    }}
  />
</Col>
              </Row>
              <Row>
                <Col md={6}>
                  <Label>Condiciones</Label>
                  <Input
                    type="textarea"
                    placeholder="Condiciones"
                    value={condiciones}
                    required
                    rows={3}
                    onChange={(e) => {
                      setCondiciones(e.target.value);
                    }}
                  />
                </Col>
                <Col md={6}>
                  <Label>Observaciones</Label>
                  <Input
                    type="textarea"
                    placeholder="Observaciones"
                    value={observaciones}
                    rows={3}
                    onChange={(e) => {
                      setObservaciones(e.target.value || "NA");
                    }}
                  />
                </Col>
              </Row>
            <Row>
              <Col md={10}>
                <h4 id="logoutBoton">
                  TOTALES {total_piezas} pzas. /{" "}
                  {"$" + new Intl.NumberFormat("en-US").format(total_general)}
                </h4>
              </Col>
            </Row>
            <br />
            {/* Tabla Articulos */}

            <Row>
              <Col md={2}>
                <Label className="mr-sm-2">Area</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Departamento</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Articulo</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Obs. Artículo</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Tela</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Precio</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Piezas</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Total</Label>
              </Col>
            </Row>

{inputFields.map((inputField) => (
  <div
    key={inputField.id}
    // style={{
    //   borderBottom: "1px solid #ccc",
    //   paddingBottom: "1rem",
    //   marginBottom: "1rem",
    // }}
  >
    {/* Fila principal del artículo */}
    <Row>
      <Col md={2}>
  {/* (2026-11) un prospecto no tiene áreas: sin el disabled el required impedía guardar */}
  <Input
    type="select"
                  required
    disabled={destino === "prospecto"}
    value={inputField.areasClientes}
    onChange={(e) =>
      handleInputFieldChange(inputField.id, "areasClientes", e.target.value)
    }
  >
    <option value="">{destino === "prospecto" ? "No aplica" : "Selecciona área"}</option>
    {areasClientesOptions.map((area) => (
      <option key={area._id} value={area._id}>
        {area.nombre || area.name}
      </option>
    ))}
  </Input>
</Col>
<Col md={1}>
  <Input
    type="select"
                  required
    value={inputField.departamentos}
    onChange={(e) =>
      handleInputFieldChange(inputField.id, "departamentos", e.target.value)
    }
  >
    <option value="">Selecciona</option>
    {departamentos.map((a) => (
      <option key={a._id} value={a._id}>
        {a.name}
      </option>
    ))}
  </Input>
</Col>
      <Col md={2}>
        <Autocomplete
          size="small"
          value={
            options2.find((o) => o._id === inputField.articulos) || null
          }
          onChange={(event, selectedArticulo) =>
            BuscaArticulo(inputField.id, selectedArticulo)
          }
          options={options2.sort((a, b) =>
            -b.firstLetter.localeCompare(a.firstLetter)
          )}
          groupBy={(option) => option.firstLetter}
          getOptionLabel={(option) => option.name || option.junta || ""}
          renderInput={(params) => (
            <TextField {...params} label="Articulo" variant="outlined" />
          )}
          renderOption={(option) => (
            <React.Fragment>{option.name}</React.Fragment>
          )}
        />
      </Col>

      <Col md={2}>
        <Input
          name="observacionesArticulo"
          type="text"
          placeholder="Obs. Artículo"
          value={inputField.observacionesArticulo ?? ""}
          disabled={!inputField.articulosNombre}
          onChange={(e) =>
            handleInputFieldChange(
              inputField.id,
              "observacionesArticulo",
              e.target.value
            )
          }
        />
      </Col>
      <Col md={1}>
        <Input
          name="tela"
          type="text"
                  required
          placeholder="Tela"
          value={inputField.tela || ""}
          onChange={(e) =>
            handleInputFieldChange(
              inputField.id,
              "tela",
              e.target.value
            )
          }
    disabled={!inputField.articulosNombre}
        />
      </Col>

      <Col md={1}>
        <Input
          name="precio"
          type="number"
                  required
          placeholder="Precio"
          value={inputField.precio}
          onChange={(e) =>
            handleInputFieldChange(
              inputField.id,
              "precio",
              parseFloat(e.target.value) || 0
            )
          }
    disabled={!inputField.articulosNombre}
        />
      </Col>

      <Col md={1}>
        <Input
          name="cantidad"
          type="number"
                  required
          placeholder="Piezas"
          value={inputField.cantidad}
           onChange={(e) =>
            handleInputFieldChange(
              inputField.id,
              "cantidad",
              parseFloat(e.target.value) || 0
            )
          }
    disabled={!inputField.articulosNombre}
        />
      </Col>

      <Col md={1}>
        <Input
          name="total"
          type="number"
          placeholder="Total"
          value={inputField.total}
          disabled
        />
      </Col>


      <Col>
        <Button
          size="sm"
          color="danger"
          disabled={inputFields.length === 1}
          onClick={() => handleRemoveFields(inputField.id)}
          tabIndex="-1"
        >
          <i className="fas fa-minus"></i>
        </Button>
        <Button
          size="sm"
          color="info"
          onClick={handleAddFields}
          tabIndex="-1"
        >
          <i className="fas fa-plus"></i>
        </Button>
      </Col>
    </Row>

    {/* Tallas por color debajo */}
    {/* {inputField.arrayColoresArticulo.map((col) => (
      <Row key={col._id} className="align-items-center mb-1 ps-3">
        <Col md={1}>
          <strong>{col.name}</strong>
        </Col>
        <Col md={11}>
          <Row>
            {inputField.tc
              .sort((a, b) => {
                const indexA = ordenTallas.indexOf(a.tallaNombre);
                const indexB = ordenTallas.indexOf(b.tallaNombre);
                return (
                  (indexA === -1 ? Infinity : indexA) -
                  (indexB === -1 ? Infinity : indexB)
                );
              })
              .filter((a) => a.colores === col._id)
              .map((a) => (
                <Col key={a.tallas} md="auto" className="text-center">
                  <Label>{a.tallaNombre}</Label>
                  <Input
                    bsSize="sm"
                    name="cantidad"
                    type="number"
                    value={a.cantidad}
                    onChange={(event) =>
                      handleChangeInputCantidad(
                        inputField.id,
                        a.colores,
                        a.tallas,
                        event
                      )
                    }
                    style={{ width: "60px" }}
                  />
                </Col>
              ))}
          </Row>
        </Col>
      </Row>
    ))} */}
  </div>
))}



            <Row>
              <Col md={10}>
                <h4 id="logoutBoton">
                  TOTALES {total_piezas} pzas. /{" "}
                  {"$" + new Intl.NumberFormat("en-US").format(total_general)}
                </h4>
              </Col>
            </Row>
            {/* Termina Tabla Articulos */}

            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
            <Button
              href="/ListadoCotizaciones"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
          </Form>
          <br />
          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios minutos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>
          <Modal size="xl" isOpen={modalExplosiones} toggle={toggleExplosiones}>
        <ModalHeader toggle={toggleExplosiones}>
          <h4>
            Explosion Modelo
          </h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={3}>
              <Label>Tela</Label>
            </Col>
            <Col md={2}>
              <Label>Color</Label>
            </Col>
            <Col md={2}>
              <Label>Metros Totales</Label>
            </Col>
            <Col md={3}>
              <Label>Observaciones</Label>
            </Col>
          </Row>
    
          {/* {inputFieldsTela.map((a) => (
            <div key={a.id}>
              <Row>
                <Col md={3}>
                  <Input
                    bsSize="sm"
                    name="idTela"
                    type="select"
                    value={a.idTela}
                    required
                    onChange={(event) => {
                      handleChangeInputTela(a.id, event);
                    }}
                  >
                    <option value="">Selecciona</option>
                    {telas
                      .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                      .map((a) => {
                        return (
                          <option value={a._id}>
                            {a.nombre} / {a.tiposTelas[0].name}
                          </option>
                        );
                      })}
                  </Input>
                </Col>
                <Col md={2}>
                  <Input
                    bsSize="sm"
                    name="idColor"
                    type="select"
                    value={a.idColor}
                    required
                    onChange={(event) => {
                      handleChangeInputTela(a.id, event);
                    }}
                  >
                    <option value="">Selecciona</option>
                    {colores
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((a) => {
                        return (
                          <option value={a._id}>
                            {a.name} 
                          </option>
                        );
                      })}
                  </Input>
                </Col>
                <Col md={2}>
                  <Input
                    bsSize="sm"
                    name="cantidad"
                    type="number"
                    value={a.cantidad}
                    onChange={(event) => {
                      handleChangeInputTela(a.id, event);
                    }}
                  ></Input>
                </Col>
                <Col md={3}>
                  <Input
                    bsSize="sm"
                    name="observaciones"
                    type="text"
                    value={a.observaciones}
                    onChange={(event) => {
                      handleChangeInputTela(a.id, event);
                    }}
                  ></Input>
                </Col>
                <Col>
                  <Button
                    size="sm"
                    className="btn"
                    color="danger"
                    disabled={inputFieldsTela.length === 1}
                    onClick={() => handleRemoveFieldsTelas(a.id)}
                    tabindex="-1"
                  >
                    <i class="fas fa-minus"></i>
                  </Button>
                  <Button
                    size="sm"
                    className="btn"
                    color="info"
                    onClick={handleAddFieldsTelas}
                    tabindex="-1"
                  >
                    <i class="fas fa-plus"></i>
                  </Button>
                </Col>
              </Row>
            </div>
          ))} */}
          <br />
        
          
        
          </ModalBody>
      </Modal>
        
        </div>
      ) : undefined}
    </>
  );
}

export default CotizacionesCreate;
